<template>
  <mock-up-main>
    <!-- صفحه خوش‌آمدگویی (Splash Screen) -->
    <v-fade-transition>
      <div 
        v-if="showSplash" 
        class="splash-screen d-flex flex-column justify-center align-center w-100 h-100 position-absolute"
        style="z-index: 100; background: #ffffff;"
      >
        <img 
          v-if="value?.photo?.welcome" 
          :src="value.photo.welcome" 
          alt="Welcome" 
          class="max-w-100 max-h-100 object-fit-contain"
        />
        <atom-spinner v-else :animation-duration="1000" :size="60" color="#1976d2" />
      </div>
    </v-fade-transition>

    <div class="d-flex flex-column h-100 position-relative w-100" style="overflow: hidden; background: #f8f9fa;">
      
      <!-- دکمه شناور شبکه‌های اجتماعی -->
      <floating-btn
        v-if="value?.socialMedia && Object.keys(value.socialMedia).length > 0"
        v-model="value.socialMedia"
        :color="value?.baseInfo?.sectionColor?.icon || 'pink darken-2'"
        class="position-absolute glass-float-btn"
        style="top: 25px; right: 15px; z-index: 20;"       />

      <!-- بدنه اصلی اسکرول شونده -->
      <v-card
        flat
        class="main-glass-wrapper overflow-y-auto hide-scrollbar px-3 pt-12" 
        style="height: calc(100%); position: relative; z-index: 1;"
        :style="{
          background: backgroundImage ? `url(${backgroundImage}) no-repeat center center / cover` :value?.baseInfo?.sectionColor?.backGround || 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
          color: value?.baseInfo?.sectionColor?.text || '#333333'
        }"
      > <div v-if="backgroundImage" class="bg-overlay"></div>
        <drag-list v-model="draggingKeys">
          <template v-slot:default="{ item }">
            <div :key="item.name || item" class="drag-item-wrapper mb-6 w-100 position-relative" style="z-index: 2;">

              <!-- ۱. بنر -->
             <template v-if="(item.name || item) === 'banner' && computedBanner">
                <div v-if="computedBanner" class="banner-glass-container elevation-4 rounded-xl overflow-hidden mb-4">
                  <b-intro-slider-view
                    v-model="computedBanner"
                    :is-slider="false"
                    type="banner"
                  />
                </div>
              </template>

              <!-- ۲. پروفایل -->
              <template v-if="(item.name || item) === 'profile' && (value?.website || value?.photo?.profile)">
                <div                 
                 class="profile-glass-card d-flex flex-column align-center text-center py-5 px-3 elevation-4 rounded-xl position-relative mt-12 mb-4"
                                 style=" background: rgba(255,255,255,0.1); backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);">
                  <div class="avatar-wrapper elevation-8"  v-if="value?.photo?.profile">
                    <img 
                      v-if="value?.photo?.profile" 
                      :src="value.photo.profile" 
                      alt="Profile" 
                      style="width: 100%; height: 100%; object-fit: cover;"
                    />
                    <!-- <v-icon v-else size="50" color="grey darken-2">mdi-account</v-icon> -->
                  </div>
                  <h2 class="font-weight-black mt-4 text-h5 mb-1 text-truncate w-100 px-2" v-if="value?.website || value?.photo?.profile"
                  
                   :style="{ color: value?.baseInfo?.sectionColor?.text || '#2c3e50' }">
                    {{ value?.visitName || '' }}
                  </h2>
                  <!-- <p v-if="value?.subtitle" class="font-weight-medium text-subtitle-2 opacity-80 mb-0 px-2">
                    {{ value.subtitle }}
                  </p> -->
                    <!-- نمایش Website -->
                    <a 
                      v-if="value?.website" 
                      :href="value.website.startsWith('http') ? value.website : 'https://' + value.website" 
                      target="_blank" 
                      class="text-decoration-none mt-3 d-flex align-center justify-center font-weight-medium px-4 py-2 rounded-pill"
                      :style="{ 
                        color: value?.baseInfo?.sectionColor?.text || '#1976d2',
                        background: 'rgba(255,255,255,0.2)',
                        maxWidth: '100%'
                      }"
                    >
                      <v-icon small class="mr-2" :color="value?.baseInfo?.sectionColor?.text || '#1976d2'">mdi-web</v-icon>
                      
                      <span 
                        class="d-inline-block text-truncate" 
                        style="max-width: 190px; direction: ltr; text-align: left;"
                      >
                        {{ value.website.replace(/^https?:\/\//, '') }}
                      </span>
                    </a>
                </div>
              </template>

              <!-- ۳. درباره ما -->
              <template v-if="(item.name || item) === 'about' && value?.aboutUs && value?.designSettings?.layout!=='SocialExpandable'">
                <div class="about-glass-card rounded-xl pa-4 elevation-3 mb-4" style=" background: rgba(255,255,255,0.1); backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);">
                  <div class="d-flex align-center mb-2">
                    <v-icon :color="value?.baseInfo?.sectionColor?.text || '#333'" class="mr-2 ml-2">mdi-text-account</v-icon>
                    <h3 class="text-subtitle-1 font-weight-bold mb-0">درباره من</h3>
                  </div>
                  <p class="about-us-text text-justify mb-0 opacity-90 text-body-2">
                    {{ value.aboutUs }}
                  </p>
                </div>
              </template>
              <!-- ۴. شبکه‌های اجتماعی (ارتباط با ما) -->
              <template v-if="(item.name || item) === 'socialMedia' &&((value?.socialMedia && Object.keys(value?.socialMedia).length > 0)|| value.profile)">
                <div class="social-glass-container rounded-xl elevation-2 py-4 px-1 mt-4" 
                    style="background: rgba(255,255,255,0.1); backdrop-filter: blur(10px); display: block;">
                  <view-social v-model="value" :showHeader="true" style="width: 100%;"/>
                </div>
              </template>

            </div>
          </template>
        </drag-list>
        
        <div style="height: 160px; width: 100%; display: block; clear: both;"></div>
      </v-card>

        <div 
          class="fixed-footer w-100 position-absolute d-flex flex-column align-center pb-2 pt-3 px-4 elevation-10" 
          style="bottom: 0; z-index: 10; background: rgba(255,255,255,0.1); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(10px); border-top-left-radius: 20px; border-top-right-radius: 20px;"
        >  
        <div class="d-flex flex-row w-100">
        <!-- <v-btn
          @click="getVcf"
          :loading="loadingVcf"
          rounded
          class="vcf-btn font-weight-bold text-subtitle-1 mb-2 elevation-4 white--text"
          height="48"
          :style="{
                width: (value?.customerClub && (value.customerClub.configs?.isActive || value.customerClub.title?.trim() || value.customerClub.description?.trim())) ? '85% !important' : '100% !important',
                background: `${value?.baseInfo?.sectionColor?.backGround} !important` || '#1976d2',
                color: `${value?.baseInfo?.sectionColor?.text} !important` || '#ffffff !important'
            
          }"
        >
          <v-icon right class="ml-2">mdi-account-plus</v-icon>
          ذخیره در مخاطبین
        </v-btn>      -->
                <v-tooltip 
            v-if="value?.customerClub && (value.customerClub.configs?.isActive || value.customerClub.title?.trim() || value.customerClub.description?.trim())"
              :value="
                value.advanceSettings &&
                value.advanceSettings.viewConfigs.showCClubOnload
              "
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="vcf-btn font-weight-bold text-subtitle-1 mb-2 elevation-4 white--text mx-1"
                  dark
                  fab
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="show"
                  height="48"
                  width="48"
                  :style="{
                      background: `${value?.baseInfo?.sectionColor?.backGround} !important` || '#1976d2',
                      color: `${value?.baseInfo?.sectionColor?.text} !important` || '#ffffff !important'
                      
                    }"

                >
                  <v-icon>mdi-card-account-phone-outline</v-icon>
                </v-btn>
              </template>
              <span>{{
                value.advanceSettings &&
                value.advanceSettings.viewConfigs.showCClubOnload
                  ? "نمایش خودکار"
                  : "باشگاه مشتریان"
              }}</span>
            </v-tooltip>
        </div>
   
        <div class="d-flex align-center justify-center opacity-70" @click="openLink">
                    <img src="/media/cr_logo.webp" alt="Terminal Ads Logo" height="18" style="filter: grayscale(30%);" />
          <span class="text-caption font-weight-medium mr-2" style="color: #666;">قدرت گرفته از کیوآر لند</span>
        </div>
      </div>
          
        </div>
      </mock-up-main>
    </template>

<script>
import DragList from "@/view/pages/qrland/dragList"; 
import BIntroSliderView from "../../../../pages/businessPage/components/view/bIntroSliderView";
import ShowInfo from "@/view/pages/otherQrTypes/photoGallery/components/showInfo";
import BGalleryView from "@/view/pages/businessPage/components/view/bGalleryView";
import FloatingBtn from "./floatingBtn.vue";
import ViewPage from "@/view/pages/businessPage/components/view/viewPage";
import GallerySlider from "@/view/pages/businessPage/components/view/gallerySlider";
import {
  VFadeTransition,
  VScaleTransition,
  VSlideXTransition,
  VSlideYTransition,
} from "vuetify/lib/components";
import { Bus } from "@/main";
import VideoCardView from "@/view/pages/otherQrTypes/videoGallery/components/videoCardView";
import ViewSocial from "@/view/pages/otherQrTypes/socialMedia/component/viewSocial";
import MockUpMain from "../../../businessPage/components/mockUp";
import { AtomSpinner } from "epic-spinners"; 
import { Width } from "../../../../../core/plugins/TitleRibbon/plugins/EasyModal/store/global/index.js";


export default {
  name: "socialMobile1_ok",
  components: {
    MockUpMain,
    DragList,
    ViewSocial,
    BIntroSliderView,
    FloatingBtn,
    AtomSpinner
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
     orders: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showconncet: false,
      showSplash: true,
      loadingVcf: false,
    };
  },
  computed: {
      draggingKeys: {
      get() {
        return this.orders && this.orders.length > 0 
          ? this.orders 
          : [
              { name: 'banner' },
              { name: 'profile' },
              { name: 'about' },
              { name: 'socialMedia' }
            ];
      },
      set(val) {
        this.$emit('update:orders', val);        
      }
    },
        backgroundImage() {
      const firstGallery = this.value?.photo?.headBackground;
        return firstGallery;      
    },
 computedBanner: {
      get() {
        if (this.value?.banner?.gallery?.[0]?.images?.length > 0) {
          return {
            banner: this.value.banner.gallery[0]
          };
        }
        return null;
      }
    }  },
  mounted() {
    Bus.$on("showMe", () => {
      this.showSplash = true;
      setTimeout(() => {
        this.showSplash = false;
      }, 3000); // 3 ثانیه نمایش اسپلش
    });
    
    setTimeout(() => {
      this.showSplash = false;
    }, 3000);
  },
  methods: {
      openLink(){
    window.open('https://qrland.ir', '_blank');
  },

      show() {
      this.showconncet = !this.showconncet;
      Bus.$emit("showconnect", this.showconncet);
    },
    getVcf() {
      this.loadingVcf = true;
      try {
        const data = this.value?.data || this.value;
        const name = data.organizationName || data.visitName || "مخاطب جدید";
        
        // تابع کمکی برای escape کردن کاراکترهای خاص
        const escapeStr = (str) => {
          if (!str) return '';
          return String(str)
            .replace(/\\/g, '\\\\')
            .replace(/\n/g, '\\n')
            .replace(/,/g, '\\,')
            .replace(/;/g, '\\;');
        };

        // تابع برای تا کردن (fold) خطوط بلند vCard (حداکثر 75 کاراکتر)
        const foldLine = (line) => {
          const result = [];
          let current = line;
          while (current.length > 75) {
            result.push(current.substring(0, 75));
            current = " " + current.substring(75);
          }
          result.push(current);
          return result.join("\r\n");
        };

        let vcard = [];
        vcard.push("BEGIN:VCARD");
        vcard.push("VERSION:3.0");
        vcard.push(`PRODID:-//Terminal Ads//FA//EN`);
        vcard.push(`FN:${escapeStr(name)}`);
        vcard.push(`N:${escapeStr(name)};;;;`);

        if (data.organizationName) {
          vcard.push(`ORG:${escapeStr(data.organizationName)}`);
        }
        if (data.website) {
          vcard.push(`URL:${escapeStr(data.website)}`);
        }
        if (data.aboutUs) {
          vcard.push(`NOTE:${escapeStr(data.aboutUs)}`);
        }

        // بررسی شبکه‌های اجتماعی
        const socialPlatforms = ['instagram', 'telegram', 'whatsapp', 'linkedin', 'twitter', 'x', 'facebook', 'youtube', 'github', 'tiktok', 'pinterest', 'twitch', 'aparat', 'eitaa', 'bale', 'rubika', 'soroush', 'gap', 'igap', 'virgool'];
        
        if (data.socialMedia) {
          Object.keys(data.socialMedia).forEach(key => {
            const val = data.socialMedia[key];
            if (!val) return;
            
            const cleanVal = escapeStr(val);
            
            if (key.toLowerCase() === 'whatsapp') {
              // واتساپ هم به عنوان شماره و هم شبکه اجتماعی اضافه می‌شود
              vcard.push(`TEL;TYPE=WORK,VOICE:${cleanVal}`);
              vcard.push(`URL;TYPE=WhatsApp:https://wa.me/${cleanVal.replace(/[^0-9]/g, '')}`);
            } else if (['phone', 'mobile', 'call'].includes(key.toLowerCase())) {
              vcard.push(`TEL;TYPE=CELL,VOICE:${cleanVal}`);
            } else if (key.toLowerCase() === 'email') {
              vcard.push(`EMAIL;TYPE=INTERNET:${cleanVal}`);
            } else if (key.toLowerCase() === 'address') {
              vcard.push(`ADR;TYPE=WORK:;;${cleanVal};;;;`);
            } else if (socialPlatforms.includes(key.toLowerCase())) {
              vcard.push(`X-SOCIALPROFILE;TYPE=${key.toLowerCase()}:${cleanVal}`);
            }
          });
        }

        vcard.push("END:VCARD");
        
        const vcardString = vcard.map(foldLine).join('\r\n');
        const blob = new Blob([vcardString], { type: 'text/vcard;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${name.replace(/\s+/g, "_")}.vcf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);

      } catch (error) {
        console.error("Error generating VCF:", error);
      } finally {
        this.loadingVcf = false;
      }
    }
  }
};
</script>

<style scoped>
/* مخفی کردن اسکرول بار اما حفظ قابلیت اسکرول */
.hide-scrollbar {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

/* افکت‌های گلس مورفیسم برای لایه‌ها */
.glass-float-btn {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
}

.banner-glass-container {
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.4);
}

.profile-glass-card, .about-glass-card, .social-glass-container {
  background: rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.1) !important;
}
.social-glass-container {
  box-sizing: border-box !important;
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden; 
}

.profile-glass-card {
  padding-top: 45px !important; 
}

.avatar-wrapper {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -55px; 
  border: 4px solid rgba(255, 255, 255, 0.6);
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%); 
  z-index: 5;
}

* {
  font-family: 'Vazirmatn', 'Vazir', Tahoma, sans-serif;
}
::v-deep .social-glass-container a, 
::v-deep .social-glass-container span,
::v-deep .social-glass-container p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
  direction: ltr;
  display: inline-block;
}
.drag-item-wrapper{
  box-sizing: border-box !important;
  min-width: 80% !important;
}
.bg-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.3); 
  backdrop-filter: blur(4px);
  z-index: 1;
}

</style>
